/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

// Revenue centers carry this row in place of Labor %. Toast's time entries have no
// revenue-center dimension, so per-center labor is apportioned by share of net sales
// rather than measured — reading it as measured performance would be misleading, which
// is why it is worded and styled differently everywhere it appears.
export const ALLOCATED_METRIC = "allocated_labor_cost";

export const METRIC_DESCRIPTIONS = {
  gross_sales: "Total sales before any discounts are taken off.",
  net_sales: "Total sales after discounts.",
  covers: "Number of guests served.",
  avg_check: "Average amount spent per guest.",
  promo_percent: "Percent of sales given away as discounts.",
  void_qty: "Number of items voided.",
  labor_percent: "Labor cost as a percent of net sales.",
  [ALLOCATED_METRIC]:
    "This center's share of the restaurant's labor cost, apportioned by its share of net sales. It is an estimate, not measured labor for this center.",
};
